export default {
  s: '%d ثانية',
  smicro: '%d ثانية',
  smid: '%d ثانية',

  ss: '%d ثانية',
  ssmicro: '%d ثانية',
  ssmid: '%d ثانية',

  m: '%d دقائق',
  mmicro: '%d دقائق',
  mmid: '%d دقائق',

  mm: '%d دقائق',
  mmmicro: '%d دقائق',
  mmmid: '%d دقائق',

  h: '%d ساعة',
  hmicro: '%d ساعة',
  hmid: '%d ساعة',

  hh: '%d ساعة',
  hhmicro: '%d ساعة',
  hhmid: '%d ساعة',

  d: '%d أيام',
  dmicro: '%d أيام',
  dmid: '%d أيام',

  dd: '%d أيام',
  ddmicro: '%d أيام',
  ddmid: '%d أيام',
};
